// extracted by mini-css-extract-plugin
export var container = "_cn-0";
export var infoIcon = "_cn-2";
export var titleRowCol = "_cn-1";